import {Params} from '@feathersjs/feathers'

import {Price, PriceId, ProviderId} from '../../types'

import * as feathersService from '../feathers'

export type PriceRequest = Omit<Price, 'id' | 'createdAt' | 'updatedAt'>

export const RESOURCE = 'price'

const get = async (params?: Params) => feathersService.find<Price>(RESOURCE, params)

export const getById = async (id: PriceId) => feathersService.get<Price>(RESOURCE, id)

export const getByProvider = async (provider: ProviderId) => {
  const parameters = {
    query: {
      provider,
    },
  }
  return get(parameters)
}

export const create = async (payload: PriceRequest) =>
  feathersService.create<Price, PriceRequest>(RESOURCE, payload)

export const createMultiple = async (payload: PriceRequest[]) =>
  payload.length > 0
    ? feathersService.createMultiple<Price, PriceRequest>(RESOURCE, payload)
    : Promise.resolve([])

export const update = async (payload: Price, id: PriceId) =>
  feathersService.update<Price>(RESOURCE, id, payload)

export const updateMultiple = async (payload: Price, ids: PriceId[]) =>
  Promise.all(ids.map(id => update(payload, id)))

export const patch = async (payload: Partial<PriceRequest>, id: PriceId) =>
  feathersService.patch<Price>(RESOURCE, id, payload)

export const patchMultiple = async (payload: Partial<PriceRequest>, ids: PriceId[]) =>
  Promise.all(ids.map(id => patch(payload, id)))

export const remove = async (id: PriceId) => feathersService.remove<Price>(RESOURCE, id)

export const removeMultiple = async (ids: PriceId[]) => Promise.all(ids.map(id => remove(id)))
